module.exports = __webpack_public_path__ + "static/media/bulk_master_plant.c030a763.csv";